import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
    
  constructor(private readonly http: HttpClient) {}

  get(url: string, options?: { params?: HttpParams | { [param: string]: string | string[] }, headers?: HttpHeaders }): Observable<any> {
    return this.http.get<any>(url, options);
  }
  
  put(url: string, body?: any): Observable<any> {
    return this.http.put<any>(url, body);
  }

  post(url: string, body?: any, options?: { headers?: HttpHeaders }): Observable<any> {
    return this.http.post<any>(url, body, options);
  }

  delete(url: string): Observable<any> {
    return this.http.delete<any>(url);
  }
}
